/** Los importes viajan en centavos. Acá y solo acá se convierten a pesos. */
export function pesos(centavos: number): string {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency', currency: 'ARS', maximumFractionDigits: 0,
  }).format(centavos / 100);
}

export function fechaLarga(fecha: string): string {
  return new Intl.DateTimeFormat('es-AR', {
    weekday: 'long', day: 'numeric', month: 'long',
  }).format(new Date(`${fecha}T12:00:00`));
}

const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

function diasDesdeHoy(fecha: string): number {
  const hoy = new Date();
  hoy.setHours(12, 0, 0, 0);
  return Math.round((new Date(`${fecha}T12:00:00`).getTime() - hoy.getTime()) / 86_400_000);
}

/** "Hoy", "Mañana", "El jueves" o "El 14/10", como se lo diría una persona. */
export function cuandoEs(fecha: string): string {
  const dias = diasDesdeHoy(fecha);
  if (dias === 0) return 'Hoy';
  if (dias === 1) return 'Mañana';
  const dia = new Date(`${fecha}T12:00:00`);
  if (dias > 1 && dias < 7) return `El ${DIAS[dia.getDay()]}`;
  return `El ${dia.getDate()}/${dia.getMonth() + 1}`;
}

// Aritmética de fechas 'AAAA-MM-DD'. El mediodía evita que el huso horario corra un día.
const aDate = (fecha: string) => new Date(`${fecha}T12:00:00`);
const aTexto = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function hoyIso(): string {
  return aTexto(new Date());
}

export function sumarDias(fecha: string, dias: number): string {
  const d = aDate(fecha);
  d.setDate(d.getDate() + dias);
  return aTexto(d);
}

export function lunesDe(fecha: string): string {
  return sumarDias(fecha, -((aDate(fecha).getDay() + 6) % 7));
}

/** "14/09", para listas y tablas donde la fecha larga no entra. */
export function fechaCorta(fecha: string): string {
  return `${fecha.slice(8, 10)}/${fecha.slice(5, 7)}`;
}

export function diaDeLaSemana(fecha: string): string {
  return DIAS[aDate(fecha).getDay()] ?? '';
}

/** "10,8 %" con la coma decimal de acá, que es lo que entiende la animación de los KPI. */
export function porcentaje(valor: number): string {
  return `${valor.toLocaleString('es-AR', { maximumFractionDigits: 1 })}%`;
}

/** "4,1": un decimal con coma, para puntajes. */
export function decimal(valor: number): string {
  return valor.toLocaleString('es-AR', { maximumFractionDigits: 1 });
}
